import { DialogTitle as Mui4DialogTitle, DialogTitleProps as Mui4DialogTitleProps } from '@material-ui/core'
import { default as Mui5DialogTitle } from '@mui/material/DialogTitle'
import { forwardRef } from 'react'
import { useComponentVersion } from '../hooks'
import { OsDialogVersion } from './Dialog'

export type DialogTitleProps = Mui4DialogTitleProps
/** @deprecated Use DialogTitleProps */
export type OsDialogTitleProps = DialogTitleProps

export const DialogTitle = forwardRef<HTMLSpanElement | unknown, DialogTitleProps>((props, ref) => {
  const version = useComponentVersion('dialog')
  switch (version) {
    case OsDialogVersion.V2:
      //@ts-ignore
      return <Mui5DialogTitle ref={ref} {...props} />

    default:
      return <Mui4DialogTitle ref={ref} {...props} />
  }
})
